import { render, staticRenderFns } from "./ContactClienteSolcitudInfo.vue?vue&type=template&id=5e60537a&scoped=true&"
import script from "./ContactClienteSolcitudInfo.vue?vue&type=script&lang=js&"
export * from "./ContactClienteSolcitudInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactClienteSolcitudInfo.vue?vue&type=style&index=0&id=5e60537a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e60537a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
